import React, { useCallback, useState } from 'react';
import { useSelector } from '@yme/hooks/useSelector';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getModalData } from '@yme/modals/selectors';
import { getRTL, getIsoCountryCode } from '@yme/selectors/common';
import { MapModalDesktop } from './desktop/MapModalDesktop';
import { MapModalMobile } from './mobile/MapModalMobile';
export function MapModal() {
    const isRightToLeft = useSelector(getRTL);
    const { googleApiKey, myGeolocation, inputLocation, selectedDealerId: preSelectedDealerId, dealers, setInputLocation, onDealerSubmit, isHiddenCloseIcon, } = useSelector(getModalData);
    const isoCountryCode = useSelector(getIsoCountryCode);
    const { isInfiniteDesktopView: isDesktop } = useWindowSize();
    const [selectedDealerId, setSelectedDealerId] = useState(preSelectedDealerId || null);
    const handleMapInfoWindowDismiss = useCallback(() => {
        onDealerSubmit(null);
    }, [onDealerSubmit]);
    const submitDealer = useCallback((vicinityId) => {
        onDealerSubmit(vicinityId);
    }, [onDealerSubmit]);
    const MapModalComponent = isDesktop ? MapModalDesktop : MapModalMobile;
    return (React.createElement(MapModalComponent, { country: isoCountryCode, googleApiKey: googleApiKey, dealers: dealers, selectedDealerId: selectedDealerId, preselectedDealerId: undefined, myLocation: myGeolocation, inputLocation: inputLocation, isRightToLeft: isRightToLeft, handleMapInfoWindowDismiss: handleMapInfoWindowDismiss, submitDealer: submitDealer, setSelectedDealerId: setSelectedDealerId, setInputLocation: setInputLocation, isHiddenCloseIcon: isHiddenCloseIcon }));
}
